import React from 'react';
import { Styler, FlexGrid, TypographyHeading, Stacker, Button, Paper } from '@honeycomb/ui-core';
import { RESPONSIVE_PAPER_PROPS } from '../../../utils/style-constants';
export function AccountScreenContainer({ onFormSubmit, formId, heading, subHeading, buttonLabel, children, footer, hidden, loading = false, }) {
    return (React.createElement(FlexGrid, { container: true, xs: "fill", alignItems: "center", justifyContent: "center", fullHeight: true },
        React.createElement(Styler, { p: 4, pt: 20, maw: 400 },
            React.createElement(Paper, Object.assign({}, RESPONSIVE_PAPER_PROPS),
                React.createElement("form", { noValidate: true, autoComplete: "off", onSubmit: (e) => {
                        e.preventDefault();
                        onFormSubmit(e);
                    }, id: formId },
                    !!hidden && hidden,
                    React.createElement(Stacker, { spacing: 6 },
                        React.createElement(TypographyHeading, { component: "h2", color: "text.heading", size: "m" }, heading),
                        React.createElement("p", null, subHeading),
                        children && React.Children.map(children, (child) => React.createElement("div", null, child)),
                        React.createElement(Button, { loading: loading, color: "callToAction", size: "xl", fullWidth: true, type: "submit" }, buttonLabel)),
                    footer)))));
}
